import { Container, Row, Col } from 'tunggal';
import React from 'react';
export default {
  Container,
  Row,
  Col,
  React
};